import packageJson from '../../package.json';

// ROLE CONSTANTS

export const APPROVAL_ROLES = {
  MANAGER: 'manager',
  HOC: 'hoc',
  CEO: 'ceo',
};

export const USER_ROLES = {
  SUPERADMIN: 'SUPERADMIN',
};

// APP CONSTANTS

export const DISCOUNT_TYPES = {
  PERCENTAGE: 'PERCENTAGE',
  AMOUNT: 'AMOUNT',
};

export const WO_STATUSES = {
  NEW: 'NEW',
  CREATED: 'CREATED',
  REJECTED: 'REJECTED',
  PROGRESS: 'PROGRESS',
  UPDATED: 'UPDATED',
  APPROVED: 'APPROVED',
  DISPATCH: 'DISPATCH',
  COMPLETED: 'COMPLETED',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED',
  PM_APPROVED: 'PM_APPROVED',
  TH_APPROVED: 'TH_APPROVED',
  COO_APPROVED: 'COO_APPROVED',
  PO_RAISED: 'PO_RAISED',
  DELIVERY_UPDATED: 'DELIVERY_UPDATED',
  HOLD: 'HOLD',
  DECISION_MADE: "DECISION_MADE",
  LOGISTIC_RAISED: "LOGISTIC_RAISED",
  PO_RAISED: "PO_RAISED",
};

export const LGOISTICS_STATUSES = {
  NEW: 'NEW',
  SHIPPED: 'SHIPPED',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  DELETED: 'DELETED',
};

export const commonMeasurementUnits = [
  'Unit',
  'Gram',
  'Kilogram',
  'Milliliter',
  'Litre',
  'Centimeter',
  'Inch',
  'Meter',
  'Box',
  'Piece',
  'Bundle',
  'Roll',
  'Tons',
  'sq-mt',
  'Running Meter',
  'CUM - Cubic Metre',
  'SFT - Square Feet',
  'RFT - Running feet',
  'Nos',
  'Bags',
  'Bottles',
  'CFT',
  'SET',
  'Mini Load',
  'Load',
  'Tractor',
  'Pan',
  'Length',
  'Coil',
  'Can',
];

export const commonSubMeasurementUnits = [
  'Unit',
  'Gram',
  'Kilogram',
  'Milliliter',
  'Litre',
  'Centimeter',
  'Inch',
  'Meter',
  'Box',
  'Piece',
  'Bundle',
  'Roll',
  'Tons',
  'CUM - Cubic Metre',
  'SFT - Square Feet',
  'RFT - Running feet',
  'Nos',
  'Bags',
  'CFT',
  'Coil',
  'Can',
];

export const DEFAULT_TNC = `1. All disputes are subject to local jurisdiction only.
2. Payment terms: 30 days from invoice date.
3. Delivery: As per agreed schedule.
4. Quality: As per specifications.
5. Warranty: As per manufacturer's warranty.`;

export const FILE_TYPES = {
  PROJECT_FILES: 'project_files',
  PROJECT_PICS: 'project_pics',
  TASK_FILES: 'task_files',
  PURCHASES_FILES: 'expense_files',
  SUB_TASK_FILES: 'sub_task_files',
  USER_PROFILE_PIC: 'user',
  LABOUR_FILES: 'work_summary_files',
  VEHICLE_PHOTO: 'vehicle_photo',
  VEHICLE_NUMPLATE_PHOTO: 'vehicle_numplate_photo',
  CRM_FILES:"crm_files",
  PO_PHOTOS: 'po_photos',
  LOGISTIC_PHOTO: 'logistic_photo',
  QUOTATION_FILES: 'quotation_files',
  QUOTATION_LINE_ITEM_FILES: 'quotation_line_item_files',
  COMPANY_IMAGES: 'company_images',
  TASK_COMMENTS:"task_comments", 
SUBTASK_COMMENTS:"sub_task_comments",
CRM_MOM_FILES:"crm_mom_files",
  ASSET_IMAGES: "asset_images",
  ASSET_GROUP_IMAGES: "asset_group_images",
  ASSET_EXPENSES: "asset_expense_files",
  INSURANCE_DOCUMENTS: "insurance_documents",
  PO_FILES: "po_files",
  MI_FILES: "mi_files",
  PERFORMA_INVOICE_FILES: 'performa_invoice_files',
  QUESTIONNAIRE_OPTION_IMAGES: 'questionnaire_option_images',
  QUESTIONNAIRE_RESPONSE_FILES: 'questionnaire_response_files',
  LABOUR_ATTENDANCE: 'labour_attendance',
};

export const COMPANY_IMAGE_SLOTS = [
  {
    id: 1,
    key: 'logo',
    label: 'Logo',
    width: 200,
    height: 100,
    maxSizeKb: 100,
    usage: 'Top-right corner on every page',
  },
  {
    id: 2,
    key: 'footer',
    label: 'Footer',
    width: 1200,
    height: 150,
    maxSizeKb: 200,
    usage: 'Full-width banner at bottom of every page',
  },
  {
    id: 3,
    key: 'image1',
    label: 'Image 1',
    width: 500,
    height: 200,
    maxSizeKb: 150,
    usage: 'Page 1 only — left side below quotation details',
  },
  {
    id: 4,
    key: 'image2',
    label: 'Image 2',
    width: 500,
    height: 200,
    maxSizeKb: 150,
    usage: 'Page 1 only — right side below quotation details',
  },
];

export const Version = packageJson.version;